
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');
const UpdatePTLConsignments = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();
        console.log(props,"props10")
         props.onClickActive1(props);
    
    };
    let iconColor;
    if (props.data.status === 1) {
        iconColor = '#1cc88a'; // Status 1: Green icon
    } else if (props.data.status === 2 || props.data.status === 3) {
        iconColor = '#28bad4'; // Status 2 or 3: Blue icon
    } else {
        iconColor = ''; // Default color for other statuses
    }
    return (
            <div className="map-icon-component" style={{cursor: "pointer"}}>
                <i class="icofont icofont-edit" onClick={handleRouteClick} style={{color: iconColor,height:'15px',}}></i>
                        {/* <img onClick={handleRouteClick}  src={require("../../assets/images/Update.png")} style={{height:'15px',}}/> */}


        
    </div>
               
);
    
};
export default UpdatePTLConsignments;
